export const extractCoachFrameworks = (docs = []) => {
  if (!docs || docs.length === 0) return [];
  const names = new Set();
  docs.forEach(d => {
    const title = d?.title || '';
    const content = d?.content || '';
    const hay = `${title} ${content}`;
    const patterns = [
      /(?:my\s+)?([\w\- ]{3,50})\s+(?:method|framework|system|process)/gi,
      /the\s+([\w\- ]{3,50})\s+(?:method|framework|system|process)/gi
    ];
    patterns.forEach(p => {
      const matches = [...hay.matchAll(p)];
      matches.forEach(m => { const n = (m[1] || '').trim(); if (n) names.add(n); });
    });
  });
  return Array.from(names);
};
